import React from 'react';
import { IMAGES } from 'src/shared/utils/appConstant';
import { IOT_STRINGS, cardDataRadiusDevice } from 'src/shared/utils/string';
import IOTServicePage from './IOTServicePage';

const RadiusDeviceUnlocking: React.FC = () => {
  return (
    <IOTServicePage
      title={IOT_STRINGS.RADIUS_DEVICE_UNLOCKING}
      backgroundImage={IMAGES.RADIUS_BASED_BANNER}
      cardData={cardDataRadiusDevice}
    />
  );
};

export default RadiusDeviceUnlocking;